import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type { PatientVitals } from "../types/patientVitals";
export const useCoreVitals = (
  patientId?: string,
  options?: { enabled?: boolean },
) => {
  return useApi<PatientVitals>({
    queryOptions: {
      enabled: options?.enabled ?? Boolean(patientId),
      queryKey: QueryKeys.Patient.MedicalRecords.Vitals.CORE(patientId),
      queryFn: async () => {
        const response = await axiosInstance.get(
          "/charting/vitals/simple-core-vitals",
          {
            params: {
              patientId,
            },
          },
        );
        return response.data;
      },
    },
  });
};
